import React, { useState,useRef, useEffect } from 'react';
import { Copy, Share2, FileDown, MoreHorizontal, X, Save, } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import { asBlob } from 'html-docx-js-typescript';
import { UserAuth } from '../../context/AuthContext';
import '../Chat/answer.css'
//import SVGDisplayModal from './svg_display';

const ExtendedActionButtons = ({ pregunta, textToSave, title: initialTitle, posicion = 'flex-end' }) => {
    const { token } = UserAuth();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [copyStatus, setCopyStatus] = useState('');
    const [showSaveModal, setShowSaveModal] = useState(false);
    const [showDiagramaModal, setShowDiagramaModal] = useState(false);
    const [saveTitle, setSaveTitle] = useState(initialTitle || '');
    const [saveStatus, setSaveStatus] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showSvgModal, setShowSvgModal] = useState(false);
    const [svgContent, setSvgContent] = useState('');
    const modalRef = useRef(null);
    const inputRef = useRef(null);
    const { isDarkMode, themeClass, toggleTheme } = useTheme();
    useEffect(() => {
        if (showSaveModal || showDiagramaModal) {
            setTimeout(() => {
                // Find the closest scrollable parent
                const findScrollableParent = (element) => {
                    if (!element) return document.documentElement;
                    
                    const style = window.getComputedStyle(element);
                    const hasScroll = style.overflow === 'auto' || 
                                    style.overflow === 'scroll' ||
                                    style.overflowY === 'auto' ||
                                    style.overflowY === 'scroll';
                    
                    if (hasScroll && element.scrollHeight > element.clientHeight) {
                        return element;
                    }
                    
                    return findScrollableParent(element.parentElement);
                };
    
                const scrollableParent = findScrollableParent(modalRef.current);
                scrollableParent.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
    
                // Focus the input field
                if (inputRef.current) {
                    inputRef.current.focus();
                }
            }, 100);
        }
    }, [showSaveModal, showDiagramaModal]);
    const simplifyMarkup = (markup) => {
        if (!markup) return '';
        
        return markup
            .replace(/\*\*(.*?)\*\*/g, '$1')
            .replace(/\*(.*?)\*/g, '$1')
            .replace(/```(.*?)```/g, '$1')
            .replace(/`(.*?)`/g, '$1')
            .replace(/^\s*[-*+]\s/gm, '• ')
            .replace(/^\s*#{1,6}\s*/gm, '')
            .replace(/\n{3,}/g, '\n\n')
            .trim();
    };
    const handleGenerateDiagram = async () => {
        setShowDiagramaModal(true);
        if (!textToSave) {
          setCopyStatus('No hay texto para generar el diagrama');
          setTimeout(() => setCopyStatus(''), 2000);
          setShowDiagramaModal(false);
          return;
        }
      
        if (!token) {
          setCopyStatus('No se encontró token de autenticación');
          setTimeout(() => setCopyStatus(''), 2000);
          setShowDiagramaModal(false);
          return;
        }
      
        setIsLoading(true);
        setCopyStatus('');
      
        try {
          const url = `${process.env.REACT_APP_API_BASE_URL}/api/diagrama`;
          
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
              input: pregunta+"\n"+textToSave
            })
          });
          
          const data = await response.json();
          
          if (response.ok) {
            const svgContent = data.svg || data;
            const htmlContent = `
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Diagrama Legal</title>
                    <meta charset="UTF-8">
                    <style>
                        body {
                            margin: 0;
                            font-family: system-ui, -apple-system, sans-serif;
                            text-align: justify;
                        }
                        .controls {
                            position: fixed;
                            top: 20px;
                            right: 20px;
                            background: white;
                            padding: 15px;
                            border-radius: 12px;
                            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                            display: flex;
                            gap: 10px;
                            z-index: 1000;
                        }
                        .button {
                            padding: 8px 16px;
                            border: none;
                            border-radius: 6px;
                            cursor: pointer;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            gap: 6px;
                            transition: all 0.2s;
                        }
                        .primary {
                            background: #3bf083;
                            color: black;
                        }
                        .secondary {
                            background: #f0f0f0;
                            color: black;
                        }
                        .button:hover {
                            opacity: 0.9;
                        }
                        #diagram-container {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            min-height: 100vh;
                            padding: 20px;
                        }
                        .zoom-controls {
                            position: fixed;
                            bottom: 20px;
                            right: 20px;
                            background: white;
                            padding: 10px;
                            border-radius: 12px;
                            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                        }
                    </style>
                </head>
                <body>
                    <div class="controls">
                        <button class="button primary" onclick="downloadAsPNG()">
                            💾 Descargar PNG
                        </button>
                        <button class="button primary" onclick="downloadAsSVG()">
                            📁 Descargar SVG
                        </button>
                        <button class="button primary" onclick="downloadAsPDF()">
                            📄 Descargar PDF
                        </button>
                        <button class="button secondary" onclick="shareViaWhatsApp()">
                            📱 Compartir
                        </button>
                    </div>
                    
                    <div id="diagram-container">
                        ${svgContent}
                    </div>
        
                    <div class="zoom-controls">
                        <button class="button secondary" onclick="zoomIn()">🔍+</button>
                        <button class="button secondary" onclick="zoomOut()">🔍-</button>
                        <button class="button secondary" onclick="resetZoom()">↺</button>
                    </div>
        
                    <script>
                        // Get SVG element
                        const svg = document.querySelector('svg');
                        let currentScale = 1;
                        
                        // Download as PNG
                        async function downloadAsPNG() {
                                const svgElement = document.querySelector('svg');
                                const svgData = new XMLSerializer().serializeToString(svgElement);
                                
                                // Create a new SVG blob with the correct XML declaration
                                const svgBlob = new Blob([
                                    '<?xml version="1.0" encoding="UTF-8"?>',
                                    svgData
                                ], { type: 'image/svg+xml;charset=utf-8' });
                                
                                const svgUrl = URL.createObjectURL(svgBlob);
                                
                                // Create an Image object to draw to canvas
                                const img = new Image();
                                img.src = svgUrl;
                                
                                img.onload = function() {
                                    // Create canvas with proper dimensions
                                    const canvas = document.createElement('canvas');
                                    const scale = 2; // Scale for better quality
                                    canvas.width = img.width * scale;
                                    canvas.height = img.height * scale;
                                    
                                    // Draw and download
                                    const ctx = canvas.getContext('2d');
                                    ctx.scale(scale, scale);
                                    ctx.fillStyle = 'white';
                                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                                    ctx.drawImage(img, 0, 0);
                                    
                                    const a = document.createElement('a');
                                    a.href = canvas.toDataURL('image/png');
                                    a.download = 'diagrama_legal.png';
                                    a.click();
                                    
                                    // Cleanup
                                    URL.revokeObjectURL(svgUrl);
                                };
                            }
        
                        // Download as SVG
                        function downloadAsSVG() {
                            const svgData = new XMLSerializer().serializeToString(svg);
                            const blob = new Blob([svgData], { type: 'image/svg+xml' });
                            const url = URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = 'diagrama_legal.svg';
                            a.click();
                            URL.revokeObjectURL(url);
                        }
        
                        // Share via native share dialog
                        async function shareViaWhatsApp() {
                            try {
                                const svgElement = document.querySelector('svg');
                                const svgData = new XMLSerializer().serializeToString(svgElement);
                                
                                // Create a new SVG blob with the correct XML declaration
                                const svgBlob = new Blob([
                                    '<?xml version="1.0" encoding="UTF-8"?>',
                                    svgData
                                ], { type: 'image/svg+xml;charset=utf-8' });
                                
                                const svgUrl = URL.createObjectURL(svgBlob);
                                
                                // Convert to canvas using a promise
                                const canvas = document.createElement('canvas');
                                const img = new Image();
                                
                                await new Promise((resolve, reject) => {
                                    img.onload = () => {
                                        const scale = 2; // Scale for better quality
                                        canvas.width = img.width * scale;
                                        canvas.height = img.height * scale;
                                        
                                        const ctx = canvas.getContext('2d');
                                        ctx.scale(scale, scale);
                                        ctx.fillStyle = 'white';
                                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                                        ctx.drawImage(img, 0, 0);
                                        resolve();
                                    };
                                    img.onerror = reject;
                                    img.src = svgUrl;
                                });

                                // Convert canvas to blob with specific mime type and quality
                                const blob = await new Promise(resolve => {
                                    canvas.toBlob(resolve, 'image/png', 1.0);
                                });

                                const file = new File([blob], 'diagrama_legal.png', { 
                                    type: 'image/png',
                                    lastModified: new Date().getTime()
                                });

                                // Check if Web Share API is available
                                if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
                                    await navigator.share({
                                        title: 'Diagrama Legal',
                                        text: '¡Mira este diagrama legal!',
                                        files: [file]
                                    });
                                } else {
                                    // Fallback to basic share if file sharing is not supported
                                    await navigator.share({
                                        title: 'Diagrama Legal',
                                        text: '¡Mira este diagrama legal!',
                                        url: window.location.href
                                    }).catch(() => {
                                        // If regular sharing fails, prompt to download
                                        alert('Tu navegador no soporta compartir. Por favor, usa el botón de descargar PNG.');
                                    });
                                }
                                
                                // Cleanup
                                URL.revokeObjectURL(svgUrl);
                            } catch (error) {
                                console.error('Error sharing:', error);
                                alert('No se pudo compartir la imagen. Por favor, usa el botón de descargar PNG.');
                            }
                        }
        
                        // Zoom functions
                        function zoomIn() {
                            currentScale *= 1.2;
                            svg.style.transform = \`scale(\${currentScale})\`;
                        }
        
                        function zoomOut() {
                            currentScale *= 0.8;
                            svg.style.transform = \`scale(\${currentScale})\`;
                        }
        
                        function resetZoom() {
                            currentScale = 1;
                            svg.style.transform = 'scale(1)';
                        }
                         // Download as PDF
                        async function downloadAsPDF() {
                            const svgElement = document.querySelector('svg');
                            const svgData = new XMLSerializer().serializeToString(svgElement);
                            
                            // Create data URL from SVG
                            const svgBlob = new Blob([svgData], { type: 'image/svg+xml' });
                            const url = URL.createObjectURL(svgBlob);
                            
                            // Create an iframe to load the SVG
                            const iframe = document.createElement('iframe');
                            iframe.style.visibility = 'hidden';
                            iframe.style.position = 'fixed';
                            document.body.appendChild(iframe);
                            
                            iframe.onload = function() {
                                // Once loaded, trigger print to PDF
                                iframe.contentWindow.print();
                                // Clean up
                                setTimeout(() => {
                                    document.body.removeChild(iframe);
                                    URL.revokeObjectURL(url);
                                }, 1000);
                            };
                            
                            iframe.src = url;
                        }
                    </script>
                </body>
                </html>
            `;
        
            const blob = new Blob([htmlContent], { type: 'text/html' });
            const url = URL.createObjectURL(blob);
            
            setCopyStatus(
                <div className="flex flex-col gap-2">
                    <span>¡Diagrama generado con éxito!</span>
                    <a 
                        href={url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:text-blue-700 underline"
                        onClick={() => setTimeout(() => URL.revokeObjectURL(url), 1000)}
                    >
                        Click aquí para ver el diagrama
                    </a>
                </div>
            );
        } else {
            setCopyStatus(data.error || 'Error al generar diagrama');
          }
        } catch (error) {
          console.error('Error:', error);
          setCopyStatus('Error al conectar con el servidor');
        } finally {
          setIsLoading(false);
          setIsMenuOpen(false);
          setShowDiagramaModal(false);
          // Increase the timeout for the status message since we want the user to have time to click
          setTimeout(() => setCopyStatus(''), 60000); // 10 seconds
        }
    };

    const handleSave = async () => {
        if (!saveTitle) {
            setSaveStatus('Se requiere un título');
            return;
        }

        setIsLoading(true);
        setSaveStatus('');

        try {
            const url = `${process.env.REACT_APP_API_BASE_URL_GUARDAR_PREGUNTA}/api/guardar`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    title: saveTitle,
                    content: textToSave
                })
            });

            const data = await response.json();

            if (data.success) {
                setSaveStatus('¡Guardado!');
                setShowSaveModal(false);
                setSaveTitle('');
                setTimeout(() => setSaveStatus(''), 2000);
            } else {
                setSaveStatus(data.error || 'Error al guardar');
            }
        } catch (error) {
            console.error('Error saving:', error);
            setSaveStatus('Error al guardar');
        } finally {
            setIsLoading(false);
            setIsMenuOpen(false);
        }
    };

    const actions = [
        {
            icon: <Save size={18} />,
            label: 'Guardar Pregunta',
            action: () => {
                setShowSaveModal(true);
                setIsMenuOpen(false);
            }
        },
        {
            icon: <Copy size={18} />,
            label: 'Copiar texto',
            action: () => {
                if (!textToSave) {
                    setCopyStatus('No hay texto para copiar');
                    setTimeout(() => setCopyStatus(''), 2000);
                    return;
                }
                const simplifiedText = simplifyMarkup(textToSave);
                navigator.clipboard.writeText(simplifiedText)
                    .then(() => {
                        setCopyStatus('¡Copiado!');
                        setTimeout(() => setCopyStatus(''), 2000);
                        setIsMenuOpen(false);
                    });
            }
        },
        {
            icon: <Share2 size={18} />,
            label: 'Compartir vía WhatsApp',
            action: () => {
                if (!textToSave) {
                    setCopyStatus('No hay texto para compartir');
                    setTimeout(() => setCopyStatus(''), 2000);
                    return;
                }
                const text = textToSave.replace(/<br\s*\/?>/gi, '\n')
                    .replace(/<div\s*\/?>/gi, '\n')
                    .replace(/<\/div\s*\/?>/gi, '\n')
                    .replace(/&nbsp;/g, ' ');
                const whatsappText = `*${saveTitle || 'Compartido desde Temis'}*:\n${text}`;
                const encodedText = encodeURIComponent(whatsappText + "\n\nDesbloquea el mundo del derecho con Temis: https://www.temisgpt.io");
                window.open(`https://wa.me/?text=${encodedText}`, '_blank', 'noopener,noreferrer');
                setIsMenuOpen(false);
            }
        },{
            icon: <MoreHorizontal size={18} />,
            label: 'Generar Diagrama',
            action: handleGenerateDiagram
          },
        {
            icon: <FileDown size={18} />,
            label: 'Descargar como Word',
            action: () => {
                if (!textToSave) {
                    setCopyStatus('No hay texto para descargar');
                    setTimeout(() => setCopyStatus(''), 2000);
                    return;
                }
                const htmlContent = `<!DOCTYPE html><html><head><meta charset="UTF-8"></head><body>${DOMPurify.sanitize(marked.parse(textToSave))}</body></html>`;
                asBlob(htmlContent).then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const anchor = document.createElement('a');
                    anchor.href = url;
                    anchor.download = `${saveTitle || 'documento'}.docx`;
                    document.body.appendChild(anchor);
                    anchor.click();
                    document.body.removeChild(anchor);
                    window.URL.revokeObjectURL(url);
                });
                setIsMenuOpen(false);
            },
            mobileWarning: "Descargar Word solamente funciona en PC debido al formato del documento generado"
        }
    ];

    return (
        <div style={{ position: 'relative', display: 'flex', justifyContent: posicion || 'flex-end' }}>
            <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className={`login-button blue points ${themeClass}`} 
            >
                {isMenuOpen ? <X size={20} /> : <>
                    <MoreHorizontal size={20} />
                    <span className={` optionButton  ${themeClass}`}>Opciones</span>
                </>}
            </button>

            {isMenuOpen && (
                <div className={` actionsModal ${themeClass}`} >
                    {actions.map((action, index) => (
                        <div key={index}>
                            <button
                                onClick={action.action}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    width: '100%',
                                    fontSize: '18px',
                                    padding: '12px',
                                    border: 'none',
                                    background: 'none',
                                    color: 'var(--White)',
                                    cursor: 'pointer',
                                    borderRadius: '8px',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = 'rgba(59, 240, 131, 0.1)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = 'none';
                                }}
                            >
                                <span style={{ color: 'var(--sWhite)' }}>{action.icon}</span>
                                {action.label}
                            </button>
                            {action.mobileWarning && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && (
                                <p style={{
                                    margin: '0',
                                    padding: '4px 12px',
                                    fontSize: '0.8rem',
                                    color: 'var(--inactive-color)',
                                    textAlign: 'justify', 
                                }}>
                                    {action.mobileWarning}
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            )}
            {showDiagramaModal && (
    <div className="modal-overlay" onClick={(e) => {
        if (e.target.className === 'modal-overlay' && !isLoading) {
            setShowDiagramaModal(false);
        }
    }}>
        <div className={`modal-content diagram-modal ${themeClass}`} ref={modalRef}>
            <h2 className={`diagram-title ${themeClass}`}>Generando Diagrama</h2>
            <div className="loading-content">
                <div className="loader"></div>
                <p className={`diagram-text ${themeClass}`}>Generando diagrama. Por favor, espere...</p>
            </div>
        </div>
    </div>
)}
            
            {showSaveModal && (
                <div className="modal-overlay" onClick={(e) => {
                    if (e.target.className === 'modal-overlay') {
                        setShowSaveModal(false);
                    }
                }}>
                    <div className={`modal-content savingquestion ${themeClass}`} ref={modalRef}>
                        <h2 className={`saveques ${themeClass}`}>Guardar Pregunta</h2>
                        <input
                        ref={inputRef}
                            type="text"
                            value={saveTitle}
                            onChange={(e) => setSaveTitle(e.target.value)}
                            placeholder="Ingrese un título"
                            className={`modal-input txtsavequest ${themeClass}`}
                        />
                        <div className="modal-buttons">
                            <button
                                className="content-button login-button gray"
                                onClick={() => setShowSaveModal(false)}
                                disabled={isLoading}
                            >
                                Cancelar
                            </button>
                            <button
                                className="content-button status-button login-button yellow"
                                onClick={handleSave}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Guardando...' : 'Guardar'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {copyStatus && (
                <div style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    background: '#3bf083',
                    color: '#000',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    animation: 'fadeIn 0.3s ease'
                }}>
                    {copyStatus}
                </div>
            )}

            {saveStatus && (
                <div style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    background: '#3bf083',
                    color: '#000',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    animation: 'fadeIn 0.3s ease'
                }}>
                    {saveStatus}
                </div>
            )}

            <style jsx>{`
                .modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1000;
                }

                .modal-content {
                    background: white;
                    padding: 20px;
                    border-radius: 8px;
                    width: 90%;
                    max-width: 500px;
                    position: relative;
                    top: -20vh;
                }

                .modal-content.dark {
                    background: var(--Color2);
                }

                .diagram-modal {
                    top: -20vh;
                }

                .diagram-title {
                    margin: 0;
                    color: var(--Black);
                }

                .diagram-title.dark {
                    color: var(--White);
                }

                .diagram-text {
                    color: var(--primary);
                }

                .diagram-text.dark {
                    color: var(--tertiary);
                }

                .modal-input {
                    width: 100%;
                    padding: 8px;
                    margin: 10px 0;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                }

                .modal-buttons {
                    display: flex;
                    justify-content: center;
                    gap: 10px;
                    margin-top: 20px;
                }

                h2 {
                    margin: 0;
                    color: var(--Color2);
                }

                .dark h2 {
                    margin: 0;
                    color: var(--White);
                }

                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
            
        </div>
    );
};

export default ExtendedActionButtons;